import dayjs from "dayjs";

const toDisplayDateTime = (value: string, format?: string) => {
  return dayjs(value).format(format || "LLL");
};

const DateTimeHelper = {
  toDisplayDateTime
};

export default DateTimeHelper;
